export default "/css/core.css";